
export const getMuroAplication=(state)=>{
    return state.muroSelected
}